// extracted by mini-css-extract-plugin
module.exports = {"row":"PillBox_row__dxV4Q","rightToLeft":"PillBox_rightToLeft__3Pz0Z"};